// extracted by mini-css-extract-plugin
module.exports = {"select-wrap":"select-wrap__JNJSZ","icon":"icon__3QtGq","select":"select__fv1QS","placeholder":"placeholder__17IDN"};